import StudentGroupList from "./components/List"
import StudentGroupForm from "./components/Form"
import StudentGroupView from "./components/View"

let module = "studentgroups"

export default [
  { path: "studentgroups", component: StudentGroupList, meta: { module: module, permissions: ["studentgroup-access"] } },
  {
    path: "studentgroups/create",
    component: StudentGroupForm,
    props: true,
    meta: { module: module, permissions: ["studentgroup-create"] }
  },
  {
    path: "studentgroups/edit/:id",
    component: StudentGroupForm,
    props: true,
    meta: { module: module, permissions: ["studentgroup-edit"] }
  },
  {
    path: "studentgroups/view/:id",
    component: StudentGroupView,
    props: true,
    meta: { module: module, permissions: ["studentgroup-access"] }
  }
]
